<template>
  <AdminLayout title="订单管理">
    <div class="order-list-container">
      <!-- 筛选表单 -->
      <div class="filter-form">
        <div class="form-row">
          <div class="form-item">
            <label>订单号</label>
            <div class="input-with-clear">
              <input 
                type="text" 
                v-model="filterForm.orderNo" 
                placeholder="请输入订单号"
              >
              <button 
                v-if="filterForm.orderNo" 
                class="clear-btn" 
                @click="filterForm.orderNo = ''"
              >
                ×
              </button>
            </div>
          </div>
          <div class="form-item">
            <label>客户姓名</label>
            <div class="input-with-clear">
              <input 
                type="text" 
                v-model="filterForm.customerName" 
                placeholder="请输入客户姓名"
              >
              <button 
                v-if="filterForm.customerName" 
                class="clear-btn" 
                @click="filterForm.customerName = ''"
              >
                ×
              </button>
            </div>
          </div>
          <div class="form-item">
            <label>客户电话</label>
            <div class="input-with-clear">
              <input 
                type="text" 
                v-model="filterForm.customerPhone" 
                placeholder="请输入客户电话"
              >
              <button 
                v-if="filterForm.customerPhone" 
                class="clear-btn" 
                @click="filterForm.customerPhone = ''"
              >
                ×
              </button>
            </div>
          </div>
          <div class="form-item">
            <label>接单人员</label>
            <div class="input-with-clear">
              <input 
                type="text" 
                v-model="filterForm.assigneeNickname" 
                placeholder="请输入接单人员"
              >
              <button 
                v-if="filterForm.assigneeNickname" 
                class="clear-btn" 
                @click="filterForm.assigneeNickname = ''"
              >
                ×
              </button>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-item">
            <label>订单状态</label>
            <select v-model="filterForm.status">
              <option value="">全部</option>
              <option value="待接单">待接单</option>
              <option value="已接单">已接单</option>
              <option value="已取消">已取消</option>
              <option value="已办结">已办结</option>
            </select>
          </div>
          <div class="form-item">
            <label>开始日期</label>
            <input 
              type="date" 
              v-model="filterForm.startDate" 
              placeholder="请选择开始日期"
            >
          </div>
          <div class="form-item">
            <label>结束日期</label>
            <input
              type="date"
              v-model="filterForm.endDate"
              placeholder="请选择结束日期"
            >
          </div>
          <div class="form-item">
            <label>区域</label>
            <select v-model="filterForm.customerArea">
              <option value="">全部</option>
              <option value="高淳">高淳</option>
              <option value="鼓楼">鼓楼</option>
              <option value="化工园">化工园</option>
              <option value="建邺">建邺</option>
              <option value="江宁">江宁</option>
              <option value="溧水">溧水</option>
              <option value="六合">六合</option>
              <option value="浦口">浦口</option>
              <option value="栖霞">栖霞</option>
              <option value="秦淮">秦淮</option>
              <option value="玄武">玄武</option>
              <option value="雨花">雨花</option>
              <option value="开渠">开渠</option>
            </select>
          </div>
          <div class="form-item form-actions">
            <button class="reset-btn" @click="handleReset">
              重置
            </button>
            <button class="search-btn" @click="handleSearch">
              <span class="iconify mr-2" data-icon="hugeicons:search-01"></span>
              搜索
            </button>
            <button class="export-btn" @click="handleExport">
              <span class="iconify mr-2" data-icon="hugeicons:download-01"></span>
              导出
            </button>
          </div>
        </div>
      </div>
      
      <!-- 订单列表 -->
      <div class="order-table-container">
        <table class="order-table">
          <thead>
            <tr>
              <th>订单号</th>
              <th>客户姓名</th>
              <th>客户电话</th>
              <th>区域</th>
              <th>订单状态</th>
              <th>接单人</th>
              <th>创建时间</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="order in orderList" :key="order.uuid">
              <td>{{ order.orderNo }}</td>
              <td>{{ order.customerName }}</td>
              <td>{{ order.customerPhone }}</td>
              <td>{{ order.customerArea || '-' }}</td>
              <td>
                <span class="status-tag" :class="getStatusClass(order.status)">
                  {{ order.status }}
                </span>
              </td>
              <td>{{ order.assigneeNickname || '-' }}</td>
              <td>{{ formatDate(order.createdAt) }}</td>
              <td>
                <button class="view-btn" @click="handleView(order)">
                  <span class="iconify" data-icon="hugeicons:eye-01"></span>
                  查看
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        
        <!-- 空状态 -->
      <div v-if="orderList.length === 0" class="empty-state">
        <span class="iconify" data-icon="hugeicons:empty-state-04"></span>
        <p>暂无订单数据</p>
      </div>
    </div>
    
    <!-- 订单详情模态框 -->
    <div v-if="showDetailModal" class="modal-overlay" @click="handleCloseModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>订单详情</h3>
          <button class="close-btn" @click="handleCloseModal">
            <span class="iconify" data-icon="hugeicons:cross-01"></span>
          </button>
        </div>
        <div class="modal-body">
          <!-- 加载状态 -->
          <div v-if="detailLoading" class="modal-loading">
            <span class="iconify" data-icon="hugeicons:loading-02"></span>
            <p>加载中...</p>
          </div>
          <!-- 详情内容 -->
          <div v-else-if="orderDetail" class="detail-content">
            <!-- 订单基本信息 -->
            <div class="detail-section">
              <h4>订单信息</h4>
              <div class="info-grid">
                <div class="info-item">
                  <label>订单号</label>
                  <span>{{ orderDetail.order.orderNo }}</span>
                </div>
                <div class="info-item">
                  <label>客户姓名</label>
                  <span>{{ orderDetail.order.customerName }}</span>
                </div>
                <div class="info-item">
                  <label>客户电话</label>
                  <span>{{ orderDetail.order.customerPhone }}</span>
                </div>
                <div class="info-item">
                  <label>区域</label>
                  <span>{{ orderDetail.order.customerArea || '-' }}</span>
                </div>
                <div class="info-item">
                  <label>订单状态</label>
                  <span class="status-tag" :class="getStatusClass(orderDetail.order.status)">
                    {{ orderDetail.order.status }}
                  </span>
                </div>
                <div class="info-item">
                  <label>接单人员</label>
                  <span>{{ orderDetail.order.assigneeNickname || '未分配' }}</span>
                </div>
                <div class="info-item">
                  <label>创建时间</label>
                  <span>{{ formatDate(orderDetail.order.createdAt) }}</span>
                </div>
                <div class="info-item">
                  <label>订单金额</label>
                  <span>¥{{ orderDetail.order.price.toFixed(2) }}</span>
                </div>
              </div>
            </div>
            
            <!-- 用户选择 -->
            <div class="detail-section">
              <h4>用户选择</h4>
              <div class="selections-container">
                <div 
                  v-for="(selection, key) in filteredSelections" 
                  :key="key" 
                  class="selection-item"
                >
                  <label>{{ getSelectionLabel(key) }}:</label>
                  <span>{{ selection || '未选择' }}</span>
                </div>
              </div>
            </div>
            
            <!-- 订单日志 -->
            <div class="detail-section">
              <h4>订单日志</h4>
              <div class="logs-container">
                <div v-for="(log, index) in orderDetail.logs" :key="index" class="log-item">
                  <div class="log-header">
                    <span class="log-operation">{{ log.operation }}</span>
                    <span class="log-time">{{ formatDate(log.operationTime) }}</span>
                  </div>
                  <div class="log-content">{{ log.content }}</div>
                  <div class="log-footer">
                    <span class="log-operator">操作人: {{ log.operatorName }}</span>
                    <span v-if="log.comment" class="log-comment">备注: {{ log.comment }}</span>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- 产品列表 -->
            <div class="detail-section">
              <h4>产品列表</h4>
              <table class="product-table">
                <thead>
                  <tr>
                    <th>产品名称</th>
                    <th>型号</th>
                    <th>类别</th>
                    <th>数量</th>
                    <th>价格范围</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="product in orderDetail.devices" :key="product.id">
                    <td>{{ product.name }}</td>
                    <td>{{ product.model }}</td>
                    <td>{{ product.category }}</td>
                    <td>{{ product.quantity }}</td>
                    <td>¥{{ product.minPrice.toFixed(2) }} - ¥{{ product.maxPrice.toFixed(2) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            
            <!-- 操作按钮 -->
            <div class="detail-section operation-buttons">
              <h4>操作</h4>
              <div class="buttons-container">
                <button
                  v-if="orderDetail.order.status === '待接单'"
                  class="operation-btn accept-btn"
                  @click="handleOrderAction('accept')"
                >
                  接单
                </button>
                <button
                  v-if="canOperateOrder"
                  class="operation-btn cancel-btn"
                  @click="handleOrderAction('cancel')"
                >
                  取消
                </button>
                <button
                  v-if="orderDetail.order.status === '已接单' && orderDetail.order.assignee === operatorUuid"
                  class="operation-btn complete-btn"
                  @click="handleOrderAction('complete')"
                >
                  办结
                </button>
                <button
                  v-if="(orderDetail.order.status === '已取消' || orderDetail.order.status === '已办结') && userRoleCode >= 2"
                  class="operation-btn delete-btn"
                  @click="handleDeleteOrder"
                >
                  删除
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 操作确认模态框 -->
    <div v-if="showActionModal" class="modal-overlay" @click="handleCloseActionModal">
      <div class="modal-content action-modal" @click.stop>
        <div class="modal-header">
          <h3>{{ actionModalTitle }}</h3>
          <button class="close-btn" @click="handleCloseActionModal">
            <span class="iconify" data-icon="hugeicons:cross-01"></span>
          </button>
        </div>
        <div class="modal-body">
          <div class="action-form">
            <div class="form-item">
              <label>备注 (选填)</label>
              <textarea 
                v-model="actionComment" 
                placeholder="请输入备注信息" 
                rows="4"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="cancel-action-btn" @click="handleCloseActionModal">
            取消
          </button>
          <button 
            class="confirm-action-btn" 
            :class="{ 'btn-accept': currentAction === 'accept', 'btn-cancel': currentAction === 'cancel', 'btn-complete': currentAction === 'complete' }"
            @click="confirmOrderAction"
          >
            确认
          </button>
        </div>
      </div>
    </div>
    
    <!-- 分页控件 -->
      <div class="pagination" v-if="pagination.total > 0">
        <div class="pagination-info">
          共 {{ pagination.total }} 条记录，第 {{ pagination.current }} / {{ pagination.pages }} 页
        </div>
        <div class="pagination-controls">
          <button 
            class="page-btn" 
            @click="handlePageChange(1)" 
            :disabled="pagination.current === 1"
          >
            首页
          </button>
          <button 
            class="page-btn" 
            @click="handlePageChange(pagination.current - 1)" 
            :disabled="pagination.current === 1"
          >
            上一页
          </button>
          <button 
            v-for="page in pageArray" 
            :key="page"
            class="page-btn" 
            :class="{ active: page === pagination.current }"
            @click="handlePageChange(page)"
          >
            {{ page }}
          </button>
          <button 
            class="page-btn" 
            @click="handlePageChange(pagination.current + 1)" 
            :disabled="pagination.current === pagination.pages"
          >
            下一页
          </button>
          <button 
            class="page-btn" 
            @click="handlePageChange(pagination.pages)" 
            :disabled="pagination.current === pagination.pages"
          >
            末页
          </button>
        </div>
        <div class="pagination-size">
          <span>每页显示</span>
          <select v-model="filterForm.size" @change="handleSizeChange">
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
          <span>条</span>
        </div>
        <div class="pagination-jump">
          <span>跳至</span>
          <input
            type="number"
            v-model.number="jumpPage"
            min="1"
            :max="pagination.pages"
            @keyup.enter="handleJumpPage"
            class="jump-input"
          >
          <span>页</span>
          <button class="jump-btn" @click="handleJumpPage">确定</button>
        </div>
      </div>
    </div>
  </AdminLayout>
</template>

<script>
import AdminLayout from '../../components/manage/ManageLayout.vue';
import { request } from '../../utils/request';
import config from '../../config';

const API_BASE_URL = config.API_BASE_URL;

export default {
  name: 'OrderList',
  components: {
    AdminLayout
  },
  data() {
    return {
      filterForm: {
        orderNo: '',
        customerName: '',
        customerPhone: '',
        customerArea: '',
        status: '',
        assigneeNickname: '',
        startDate: '',
        endDate: '',
        page: 1,
        size: 10
      },
      orderList: [],
      pagination: {
        total: 0,
        current: 1,
        pages: 0,
        size: 10
      },
      loading: false,
      // 订单详情相关
      showDetailModal: false,
      orderDetail: null,
      detailLoading: false,
      userRoleCode: 0,
      operatorUuid: '',
      // 操作确认模态框相关
      showActionModal: false,
      actionModalTitle: '',
      currentAction: '',
      actionComment: '',
      // 搜索防抖定时器
      searchDebounceTimer: null,
      // 跳转页码
      jumpPage: 1
    };
  },
  watch: {
    'pagination.current': {
      immediate: true,
      handler(newVal) {
        this.jumpPage = newVal;
      }
    }
  },
  computed: {
    // 计算分页页码数组
    pageArray() {
      const { current, pages } = this.pagination;
      const pageNum = [];
      
      if (pages <= 5) {
        // 如果总页数小于等于5，显示所有页码
        for (let i = 1; i <= pages; i++) {
          pageNum.push(i);
        }
      } else {
        // 显示当前页前后各2页
        let start = Math.max(1, current - 2);
        let end = Math.min(pages, start + 4);
        
        if (end - start < 4) {
          start = Math.max(1, end - 4);
        }
        
        for (let i = start; i <= end; i++) {
          pageNum.push(i);
        }
      }
      
      return pageNum;
    },
    // 解析用户选择
    parsedSelections() {
      if (!this.orderDetail || !this.orderDetail.order.selections) {
        return {};
      }
      try {
        const selections = JSON.parse(this.orderDetail.order.selections);
        return selections;
      } catch (error) {
        console.error('解析selections失败:', error);
        return {};
      }
    },
    // 过滤后的用户选择（去掉宽带类型、解决WiFi意愿、网络升级需求和WiFi覆盖信息）
    filteredSelections() {
      const filtered = {};
      for (const [key, value] of Object.entries(this.parsedSelections)) {
        if (key !== 'broadband' && key !== 'wifiSolveWill' && key !== 'networkUpgradeNeed' && key !== 'wifiCoverage') {
          filtered[key] = value;
        }
      }
      return filtered;
    },
    // 判断当前用户是否可以操作订单（取消、办结）
    canOperateOrder() {
      if (!this.orderDetail) return false;
      const order = this.orderDetail.order;
      // 待接单状态，所有人都可以取消
      if (order.status === '待接单') return true;
      // 已接单状态，只有接单人本人可以操作
      if (order.status === '已接单') {
        return order.assignee === this.operatorUuid;
      }
      return false;
    }
  },
  mounted() {
    this.getOrderList();
  },
  methods: {
    // 获取订单列表
    async getOrderList() {
      this.loading = true;
      try {
        const params = {
          ...this.filterForm
        };

        // 如果status是"全部"，传空值
        if (params.status === '') {
          params.status = '';
        }

        const response = await request(`${API_BASE_URL}/api/order/list`, {
          body: JSON.stringify(params)
        });

        if (response.code === '200') {
          this.orderList = response.data.records;
          this.pagination = {
            total: response.data.total,
            current: response.data.current,
            pages: response.data.pages,
            size: response.data.size
          };
        }
      } catch (error) {
        console.error('获取订单列表失败:', error);
      } finally {
        this.loading = false;
      }
    },
    
    // 导出Excel
    async handleExport() {
      try {
        const params = {
          ...this.filterForm
        };
        
        // 移除分页参数
        delete params.page;
        delete params.size;
        
        // 如果status是"全部"，传空值
        if (params.status === '') {
          params.status = '';
        }
        
        const response = await request(`${API_BASE_URL}/api/order/export`, {
          body: JSON.stringify(params),
          responseType: 'blob'
        });
        
        // 处理文件下载
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `订单列表_${new Date().toISOString().slice(0, 10)}.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('导出订单失败:', error);
      }
    },
    
    // 搜索
    // 搜索（带防抖）
    handleSearch() {
      // 清除之前的防抖定时器
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer);
      }
      // 设置新的防抖定时器，300ms 后执行搜索
      this.searchDebounceTimer = setTimeout(() => {
        this.filterForm.page = 1;
        this.getOrderList();
      }, 300);
    },

    // 立即搜索（用于回车键触发）
    handleSearchImmediate() {
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer);
      }
      this.filterForm.page = 1;
      this.getOrderList();
    },

    // 重置
    handleReset() {
      // 清除防抖定时器
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer);
        this.searchDebounceTimer = null;
      }
      this.filterForm = {
        orderNo: '',
        customerName: '',
        customerPhone: '',
        customerArea: '',
        status: '',
        assigneeNickname: '',
        startDate: '',
        endDate: '',
        page: 1,
        size: 10
      };
      this.getOrderList();
    },
    
    // 页码变化
    handlePageChange(page) {
      if (page >= 1 && page <= this.pagination.pages) {
        this.filterForm.page = page;
        this.getOrderList();
      }
    },
    
    // 每页条数变化
    handleSizeChange() {
      this.filterForm.page = 1;
      this.getOrderList();
    },

    // 跳转到指定页面
    handleJumpPage() {
      const page = parseInt(this.jumpPage);
      if (page >= 1 && page <= this.pagination.pages) {
        this.handlePageChange(page);
      } else {
        // 输入无效，重置为当前页
        this.jumpPage = this.pagination.current;
      }
    },

    // 查看订单详情
    async handleView(order) {
      this.detailLoading = true;
      this.showDetailModal = true;

      try {
        const params = {
          orderUuid: order.uuid
        };

        const response = await request(`${API_BASE_URL}/api/order/detail`, {
          body: JSON.stringify(params)
        });

        if (response.code === '200') {
          this.orderDetail = response.data;
          this.userRoleCode = response.userRoleCode || 0;
          this.operatorUuid = response.operatorUuid || '';
        } else {
          console.error('获取订单详情失败:', response.message);
        }
      } catch (error) {
        console.error('获取订单详情失败:', error);
      } finally {
        this.detailLoading = false;
      }
    },
    
    // 关闭模态框
    handleCloseModal() {
      this.showDetailModal = false;
      this.orderDetail = null;
    },
    
    // 获取选择项标签
    getSelectionLabel(key) {
      const labels = {
        signalProblem: '信号问题',
        houseType: '房屋户型',
        signalWeakArea: '信号薄弱区域',
        decorationStatus: '装修状态',
        prewiringStatus: '布线状态',
        broadbandInfo: '宽带信息',
        networkSpeed: '宽带网速',
        networkType: '原组网方式',
        networkSolution: '计划网络方案',
        smartDeviceCategory: '智能设备类别',
        smartDeviceInterest: '智能设备兴趣',
      };
      return labels[key] || key;
    },
    
    // 获取状态样式类
    getStatusClass(status) {
      switch (status) {
        case '待接单':
          return 'status-pending';
        case '已接单':
          return 'status-accepted';
        case '已取消':
          return 'status-canceled';
        case '已办结':
          return 'status-completed';
        default:
          return '';
      }
    },
    
    // 格式化日期
    formatDate(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    },
    
    // 处理订单操作
    handleOrderAction(action) {
      this.currentAction = action;
      switch (action) {
        case 'accept':
          this.actionModalTitle = '接单确认';
          break;
        case 'cancel':
          this.actionModalTitle = '取消订单确认';
          break;
        case 'complete':
          this.actionModalTitle = '办结订单确认';
          break;
      }
      this.actionComment = '';
      this.showActionModal = true;
    },
    
    // 关闭操作确认模态框
    handleCloseActionModal() {
      this.showActionModal = false;
      this.actionComment = '';
    },
    
    // 处理删除订单
    handleDeleteOrder() {
      if (confirm('确定要删除该订单吗？此操作不可恢复。')) {
        this.deleteOrder();
      }
    },
    
    // 删除订单
    async deleteOrder() {
      if (!this.orderDetail) return;
      
      try {
        const params = {
          orderUuid: this.orderDetail.order.uuid
        };
        
        const response = await request(`${API_BASE_URL}/api/order/delete`, {
          body: JSON.stringify(params)
        });
        
        if (response.code === '200') {
          // 操作成功，关闭模态框并刷新订单列表
          this.handleCloseModal();
          this.getOrderList();
        } else {
          console.error('删除订单失败:', response.message);
        }
      } catch (error) {
        console.error('删除订单失败:', error);
      }
    },
    
    // 确认订单操作
    async confirmOrderAction() {
      if (!this.orderDetail) return;
      
      try {
        const params = {
          orderUuid: this.orderDetail.order.uuid,
          comment: this.actionComment || ''
        };
        
        let url = '';
        switch (this.currentAction) {
          case 'accept':
            url = `${API_BASE_URL}/api/order/accept`;
            break;
          case 'cancel':
            url = `${API_BASE_URL}/api/order/cancel`;
            break;
          case 'complete':
            url = `${API_BASE_URL}/api/order/complete`;
            break;
        }
        
        const response = await request(url, {
          body: JSON.stringify(params)
        });
        
        if (response.code === '200') {
          // 操作成功，关闭模态框并刷新订单列表
          this.handleCloseActionModal();
          this.handleCloseModal();
          this.getOrderList();
        } else {
          console.error('操作失败:', response.message);
        }
      } catch (error) {
        console.error('操作失败:', error);
      }
    }
  }
};
</script>

<style scoped>
.order-list-container {
  background-color: white;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
}

/* 筛选表单样式 */
.filter-form {
  margin-bottom: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid #e5e7eb;
}

.form-row {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.form-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 200px;
  flex: 1;
}

.form-item label {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
}

.form-item input,
.form-item select {
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s;
  width: 100%;
}

/* 带清空按钮的输入框样式 */
.input-with-clear {
  position: relative;
  display: flex;
  align-items: center;
}

.clear-btn {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #6b7280;
  font-size: 24px;
  font-weight: bold;
  padding: 0 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
  background: transparent;
  border: none;
  line-height: 1;
  text-align: center;
  box-sizing: border-box;
  font-family: sans-serif;
}

.clear-btn:hover {
  color: #374151;
}

.input-with-clear input {
  padding-right: 32px;
}

.form-item input:focus,
.form-item select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.form-actions {
  align-self: flex-end;
  flex-direction: row;
  gap: 12px;
}

.search-btn {
  padding: 10px 24px;
  background-color: #3b82f6;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-btn:hover {
  background-color: #2563eb;
}

.reset-btn {
  padding: 10px 24px;
  background-color: #f3f4f6;
  color: #374151;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.reset-btn:hover {
  background-color: #e5e7eb;
}

.export-btn {
  padding: 10px 24px;
  background-color: #10b981;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
}

.export-btn:hover {
  background-color: #059669;
}

/* 订单表格样式 */
.order-table-container {
  margin-bottom: 24px;
  overflow-x: auto;
}

.order-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.order-table th,
.order-table td {
  padding: 12px 16px;
  text-align: left;
  border-bottom: 1px solid #e5e7eb;
}

.order-table th {
  background-color: #f9fafb;
  font-weight: 600;
  color: #374151;
  position: sticky;
  top: 0;
}

.order-table tr:hover {
  background-color: #f9fafb;
}

/* 状态标签样式 */
.status-tag {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.status-pending {
  background-color: #fef3c7;
  color: #d97706;
}

.status-accepted {
  background-color: #dbeafe;
  color: #1e40af;
}

.status-canceled {
  background-color: #fee2e2;
  color: #991b1b;
}

.status-completed {
  background-color: #d1fae5;
  color: #059669;
}

/* 操作按钮样式 */
.view-btn {
  padding: 6px 12px;
  background-color: #3b82f6;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  gap: 4px;
}

.view-btn:hover {
  background-color: #2563eb;
}

/* 空状态样式 */
.empty-state {
  text-align: center;
  padding: 64px 24px;
  color: #9ca3af;
}

.empty-state .iconify {
  font-size: 64px;
  margin-bottom: 16px;
  opacity: 0.5;
}

/* 模态框样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  overflow-y: auto;
}

.modal-content {
  background-color: white;
  border-radius: 8px;
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #374151;
}

.close-btn {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #6b7280;
  transition: color 0.2s;
  padding: 4px;
}

.close-btn:hover {
  color: #374151;
}

.modal-body {
  padding: 24px;
}

.modal-loading {
  text-align: center;
  padding: 64px 24px;
  color: #6b7280;
}

.modal-loading .iconify {
  font-size: 48px;
  margin-bottom: 16px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* 详情内容样式 */
.detail-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.detail-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.detail-section h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  padding-bottom: 8px;
  border-bottom: 2px solid #3b82f6;
}

/* 信息网格样式 */
.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 16px;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.info-item label {
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;
}

.info-item span {
  font-size: 14px;
  color: #374151;
}

/* 选择项样式 */
.selections-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 12px;
}

.selection-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background-color: #f9fafb;
  border-radius: 6px;
  font-size: 14px;
}

.selection-item label {
  font-weight: 500;
  color: #6b7280;
}

.selection-item span {
  color: #374151;
  font-weight: 500;
}

/* 日志样式 */
.logs-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.log-item {
  padding: 16px;
  background-color: #f9fafb;
  border-radius: 6px;
  border-left: 4px solid #3b82f6;
}

.log-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.log-operation {
  font-weight: 600;
  color: #374151;
}

.log-time {
  font-size: 12px;
  color: #6b7280;
}

.log-content {
  font-size: 14px;
  color: #374151;
  margin-bottom: 8px;
}

.log-footer {
  font-size: 12px;
  color: #6b7280;
}

.log-operator {
  margin-right: 16px;
}

/* 产品表格样式 */
.product-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.product-table th,
.product-table td {
  padding: 12px 16px;
  text-align: left;
  border-bottom: 1px solid #e5e7eb;
}

.product-table th {
  background-color: #f9fafb;
  font-weight: 600;
  color: #374151;
}

.product-table tr:hover {
  background-color: #f9fafb;
}

/* 分页样式 */
.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 24px;
  border-top: 1px solid #e5e7eb;
  flex-wrap: wrap;
  gap: 16px;
}

.pagination-info {
  font-size: 14px;
  color: #6b7280;
}

.pagination-controls {
  display: flex;
  gap: 8px;
}

.page-btn {
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background-color: white;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.page-btn:hover:not(:disabled) {
  background-color: #f3f4f6;
}

.page-btn.active {
  background-color: #3b82f6;
  color: white;
  border-color: #3b82f6;
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination-size {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #6b7280;
}

.pagination-size select {
  padding: 6px 8px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 14px;
}

/* 分页跳转样式 */
.pagination-jump {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #6b7280;
}

.jump-input {
  width: 50px;
  padding: 6px 8px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 14px;
  text-align: center;
  transition: border-color 0.2s;
}

.jump-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.jump-btn {
  padding: 6px 12px;
  background-color: #3b82f6;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.jump-btn:hover {
  background-color: #2563eb;
}

/* 操作按钮样式 */
.operation-buttons .buttons-container {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.operation-btn {
  padding: 8px 20px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 6px;
}

.operation-btn:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

.accept-btn {
  background-color: #10b981;
  color: white;
}

.cancel-btn {
  background-color: #ef4444;
  color: white;
}

.complete-btn {
  background-color: #3b82f6;
  color: white;
}

.delete-btn {
  background-color: #ef4444;
  color: white;
}

/* 操作确认模态框样式 */
.action-modal {
  width: 90%;
  max-width: 500px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #e5e7eb;
}

.action-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.action-form .form-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.action-form label {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
}

.action-form textarea {
  padding: 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  resize: vertical;
  font-family: inherit;
  transition: border-color 0.2s;
}

.action-form textarea:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.cancel-action-btn {
  padding: 8px 20px;
  background-color: #f3f4f6;
  color: #374151;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.cancel-action-btn:hover {
  background-color: #e5e7eb;
}

.confirm-action-btn {
  padding: 8px 20px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.confirm-action-btn:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

.confirm-action-btn.btn-accept {
  background-color: #10b981;
  color: white;
}

.confirm-action-btn.btn-cancel {
  background-color: #ef4444;
  color: white;
}

.confirm-action-btn.btn-complete {
  background-color: #3b82f6;
  color: white;
}
</style>
